import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import MonthYearPicker from './MonthYearPicker';
import CalendarGrid from './CalendarGrid';
import './WellnessCalendar.css';

const MONTHS = [
   'January', 'February', 'March', 'April', 'May', 'June',
   'July', 'August', 'September', 'October', 'November', 'December',
];

const WellnessCalendar = ({
   entries = [],
   selectedDate,
   onDateSelect,
   currentMonth,
   currentYear,
   onMonthChange,
}) => {
   const handlePrevMonth = () => {
      if (currentMonth === 0) {
         onMonthChange(11, currentYear - 1);
      } else {
         onMonthChange(currentMonth - 1, currentYear);
      }
   };

   const handleNextMonth = () => {
      if (currentMonth === 11) {
         onMonthChange(0, currentYear + 1);
      } else {
         onMonthChange(currentMonth + 1, currentYear);
      }
   };

   return (
      <div className="wellness-calendar">
         <div className="calendar-header">
            <button className="nav-btn" onClick={handlePrevMonth}>
               <LeftOutlined />
            </button>
            <MonthYearPicker
               currentMonth={currentMonth}
               currentYear={currentYear}
               onSelect={onMonthChange}
            >
               {MONTHS[currentMonth]} {currentYear}
            </MonthYearPicker>
            <button className="nav-btn" onClick={handleNextMonth}>
               <RightOutlined />
            </button>
         </div>

         <CalendarGrid
            currentMonth={currentMonth}
            currentYear={currentYear}
            entries={entries}
            selectedDate={selectedDate}
            onDateSelect={onDateSelect}
         />
      </div>
   );
};

export default WellnessCalendar;
